export default __webpack_public_path__ + "static/media/eye_crossed.b748d773.svg";